module.exports = __webpack_public_path__ + "img/4.e38b9092.png";